module.exports = __webpack_public_path__ + "img/fejlec_kep_egyben_372.82351442.png";